import { FilterXSS } from 'xss'

const htmlFilter = new FilterXSS({
  whiteList: {
    p: [], br: [], h2: [], h3: [], h4: [],
    strong: [], b: [], em: [], i: [], u: [], s: [], strike: [],
    blockquote: [], ul: [], ol: [], li: [],
    a: ['href', 'title', 'target'],
  },
  stripIgnoreTagBody: ['script', 'style'],
  onTagAttr(tag, name, value) {
    if (tag === 'a' && name === 'href') {
      const href = safeContentLink(value)
      return href ? `href="${escapeAttribute(href)}"` : ''
    }
    if (tag === 'a' && name === 'target' && value === '_blank') {
      return 'target="_blank" rel="noopener noreferrer"'
    }
    return undefined
  },
})

export function safeInternalPath(value: unknown, fallback = '/') {
  if (typeof value !== 'string') return fallback
  const path = value.trim()
  if (!/^\/(?!\/)/.test(path) || hasUnsafePathCharacters(path)) return fallback
  try {
    const decoded = decodeURIComponent(path)
    if (!/^\/(?!\/)/.test(decoded) || hasUnsafePathCharacters(decoded)) return fallback
  } catch {
    return fallback
  }
  return path
}

export function safeHttpUrl(value: unknown) {
  if (typeof value !== 'string' || !value.trim()) return ''
  try {
    const url = new URL(value.trim())
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return ''
    return url.href
  } catch {
    return ''
  }
}

export function safeContentLink(value: unknown) {
  if (typeof value !== 'string') return ''
  const link = value.trim()
  if (/^\/(?!\/)/.test(link)) return safeInternalPath(link, '')
  if (/^(mailto|tel):/i.test(link) && !hasControlCharacter(link)) return link
  return safeHttpUrl(link)
}

export function sanitizeRichHtml(value: unknown) {
  return htmlFilter.process(typeof value === 'string' ? value : '')
}

function hasUnsafePathCharacters(value: string) {
  return value.includes('\\') || hasControlCharacter(value)
}

function hasControlCharacter(value: string) {
  return Array.from(value).some(character => {
    const code = character.charCodeAt(0)
    return code <= 31 || code === 127
  })
}

function escapeAttribute(value: string) {
  return value.replace(/[&<>"']/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  })[character]!)
}
